import { useMemo, useState } from "react";
import { NavLink } from "react-router-dom";
import Arrow from "../../../public/images/Arrow";
import PopularIcon from "./../../../public/images/PopularIcon";
import "./pricesCards.scss";

const PERIODS = {
  month: { label: "Month", months: 1 },
  three: { label: "Three month", months: 3 },
  year: { label: "Year", months: 12, discount: 0.1 },
};

export default function PricesCards({ showButton = true, linkState }) {
  const [period, setPeriod] = useState("month");

  const prices = useMemo(() => {
    const baseMonthly = {
      basic: 40,
      starter: 60,
      pro: 80,
    };

    const { months, discount = 0 } = PERIODS[period];

    const calc = (monthly) => {
      const total = monthly * months;
      const discounted = total * (1 - discount);
      return Math.round(discounted);
    };

    return {
      basic: calc(baseMonthly.basic),
      starter: calc(baseMonthly.starter),
      pro: calc(baseMonthly.pro),
      suffix:
        period === "month"
          ? "user per month"
          : period === "three"
            ? "user / 3 months"
            : "user per year",
      showDiscount: period === "year",
    };
  }, [period]);

  return (
    <>
      <div className="buttons">
        <button
          className={period === "month" ? "buttons__active" : ""}
          onClick={() => setPeriod("month")}
          type="button"
        >
          Month
        </button>
        <button
          className={period === "three" ? "buttons__active" : ""}
          onClick={() => setPeriod("three")}
          type="button"
        >
          Three month
        </button>
        <button
          className={period === "year" ? "buttons__active" : ""}
          onClick={() => setPeriod("year")}
          type="button"
        >
          Year
        </button>
      </div>

      <div className="pricesCards">
        <div className="pricesCards__card">
          <div className="pricesCards__card__top">
            <div className="pricesCards__card__top__name">
              <h2>Basic</h2>
              <h4>
                ${prices.basic} <span>/{prices.suffix}</span>
                {prices.showDiscount}
              </h4>
            </div>

            <div className="pricesCards__card__top__line"></div>

            <div className="pricesCards__card__top__list">
              <p>
                <Arrow color="#8833FF66" /> Manager web interface
              </p>
              <p>
                <Arrow color="#8833FF66" /> Sub manager web interface
              </p>
              <p>
                <Arrow color="#8833FF66" /> Agent web interface
              </p>
              <p>
                <Arrow color="#8833FF66" /> Recordings manager web interface
              </p>
              <p>
                <Arrow color="#8833FF66" /> Work groups
              </p>
              <p>
                <Arrow color="#8833FF66" /> Messenger
              </p>
              <p>
                <Arrow color="#8833FF66" /> Pauses
              </p>
              <p>
                <Arrow color="#8833FF66" /> Custom wall
              </p>
            </div>
          </div>

          {showButton && (
            <NavLink to="/callCenter" state={linkState}>
              Get started
            </NavLink>
          )}
        </div>
        <div className="pricesCards__card">
          <div className="pricesCards__card__header">
            <p>Most popular</p>
            <div className="pricesCards__card__header__icon">
              <PopularIcon />
            </div>
          </div>
          <div className="pricesCards__card__top">
            <div className="pricesCards__card__top__name">
              <h2>Starter</h2>
              <h4>
                ${prices.starter} <span>/{prices.suffix}</span>
                {prices.showDiscount}
              </h4>
            </div>

            <div className="pricesCards__card__top__line"></div>

            <div className="pricesCards__card__top__list">
              <p>
                <Arrow color="#8833FF66" /> All include in <span>Basic</span>{" "}
                module
              </p>
              <p>
                <Arrow color="#8833FF66" /> Campaigns manage
              </p>
              <p>
                <Arrow color="#8833FF66" /> Scenario
              </p>
              <p>
                <Arrow color="#8833FF66" /> Campaign custom fields
              </p>
              <p>
                <Arrow color="#8833FF66" /> Reports
              </p>
              <p>
                <Arrow color="#8833FF66" /> SMS
              </p>
              <p>
                <Arrow color="#8833FF66" /> Fax
              </p>
              <p>
                <Arrow color="#8833FF66" /> AI
              </p>
              <p>
                <Arrow color="#8833FF66" /> API
              </p>
            </div>
          </div>

          {showButton && (
            <NavLink to="/callCenter" state={linkState}>
              Get started
            </NavLink>
          )}
        </div>

        <div className="pricesCards__card">
          <div className="pricesCards__card__top">
            <div className="pricesCards__card__top__name">
              <h2>Professional</h2>
              <h4>
                ${prices.pro} <span>/{prices.suffix}</span>
                {prices.showDiscount}
              </h4>
            </div>
            <div className="pricesCards__card__top__line"></div>

            <div className="pricesCards__card__top__list">
              <p>
                <Arrow color="#8833FF66" /> All include in <span>Starter</span>{" "}
                module
              </p>
              <p>
                <Arrow color="#8833FF66" /> True caller
              </p>
              <p>
                <Arrow color="#8833FF66" /> Office 365
              </p>
              <p>
                <Arrow color="#8833FF66" /> Whatsapp
              </p>
            </div>
          </div>

          {showButton && (
            <NavLink to="/callCenter" state={linkState}>
              Buy now
            </NavLink>
          )}
        </div>
      </div>
    </>
  );
}
